import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import './Assets/Scss/Style.scss';
import { BrowserRouter as Router, Routes, Route, Outlet, } from "react-router-dom";
import Login from './Public/Users/Login';
import Register from './Public/Users/Register';
import Forgot from './Public/Users/Forgot';
import Dashboard from './Public/HomePage/Dashboard';
import Profile from './Public/HomePage/Profile';
import Trading from './Public/HomePage/Trading';
import Team from './Public/HomePage/Team';
import Overview from './Public/HomePage/Overview';
import Ledger from './Public/HomePage/Ledger';
import PayHistory from './Public/HomePage/PayHistory';
import TradeWithdraw from './Public/HomePage/TradeWithdraw';
import SalaryWithdraw from './Public/HomePage/SalaryWithdraw';
import RankRoyalty from './Public/HomePage/RankRoyalty';
import Globalpool from './Public/HomePage/Globalpool';
import Header from './Layout/Header';
import Footer from './Layout/Footer';
import Market from './Private/Market';
// import { titleDescription } from './config/Config';
import Sidebar from './Layout/Sidebar';
import DepositBEP20 from './Public/HomePage/DepositBEP20';
import DepositTRC20 from './Public/HomePage/DepositTRC20';
import INRDeposit from './Public/HomePage/INRDeposit';
import PrivateRoutes from './config/PrivateRoutes';
import BuyInfra from './Public/HomePage/BuyInfra';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UniLevel from './Public/HomePage/UniLevel';
import Cashflow from './Public/HomePage/Cashflow';
import Presentations from './Public/HomePage/Presentations';
import Support from './Public/HomePage/Support';
import Demo from './Public/Demo';
import Index from './Public/index_page/Index';
import TicketView from './Public/HomePage/TicketView';
import PayoutRequest from './Public/HomePage/PayoutRequest';
import DirectIncome from './Public/HomePage/directIncome';
import { LanguageProvider } from "../src/LanguageContext";
import MainOverview from './Public/HomePage/MainOverview';
import About from './Public/About';
import PrivacyPolicy from './Public/PrivacyPolicy';
import HomeHeader from './Public/HomeHeader';
import Terms from './Public/Terms';
import ContactUs from './Public/ContactUs';
import WaitingScreen from './Public/WaitingScreen';
import ApprovedScreen from './Public/ApprovedScreen';
import Forgotconformation from './Public/Forgotconformation';
import AdminLogin from './Public/Users/AdminLogin';
import TradeTransfer from './Public/HomePage/TradeTransfer';
import TradePayout from './Public/HomePage/TradePayout';
import TradeFundHistory from './Public/HomePage/TradeFundHistory';
import Navbar from './Public/index_page/Navbar';
import AdminSideLogin from './Public/HomePage/AdminSideLogin';
import DepositHistory from './Public/HomePage/DepositHistory';
import INRDepositHistory from './Public/HomePage/INRDepositHistory';
import CapitalWithdrawHistory from './Public/HomePage/CapitalWithdrawHistory';
import CustomCursor from './Public/index_page/CustomCursor';
import HomeFooter from './Public/index_page/Footer'
import PayoutSummary from './Public/HomePage/PayoutSummary';
import DatewiseSummary from './Public/HomePage/DatewiseSummary';
import BotPayoutSummary from './Public/HomePage/BotPayoutSummary';
import BotDatewiseSummary from './Public/HomePage/BotDatewiseSummary';
import DirectsList from './Public/HomePage/DirectsList';
import RoyalitySummary from './Public/HomePage/RoyalitySummary';
import CompoundBonus from './Public/HomePage/CompoundBonus';
import TreeView from './Public/HomePage/TreeView';
import LedgerByType from './Public/HomePage/LedgerByType';
import PopupCompounding from './Public/HomePage/PopupCompounding';
import StakeCompounding from './Public/HomePage/StakeCompounding';
import PartiallyTopup from './Public/HomePage/PartiallyTopup';
import CompundInterestCalculator from './Public/HomePage/CompundInterestCalculator';
import GetTeamBusiness from './Public/HomePage/GetTeamBusiness';
// import PublicBottomBar from './Layout/PublicBottomBar';

function App() {

  // useEffect(() => {
  //   const darkThemePages = ["/dashboard", "/login", "/register"]; // Define pages where dark theme is needed

  //   if (darkThemePages.includes(window.location.pathname)) {
  //     document.body.setAttribute("data-theme", "dark");
  //   } else {
  //     document.body.removeAttribute("data-theme");
  //   }
  // }, []);

  // ? Login page.....
  function LoginLayout() {
    return (
      <>
        <Outlet />
      </>
    );
  }

  // ? Login page.....
  function VerificationLayout() {
    return (
      <>
        <Outlet />
        {/* <PublicBottomBar/> */}
      </>
    );
  }

  function PublicOuter() {
    return (
      <>
        {/* <HomeHeader /> */}
        {/* <CustomCursor /> */}
        <Navbar />
        <Outlet />
        <HomeFooter />

      </>
    );
  }

  // Public page.....
  function PublicLayout() {
    return (
      <>
        <Sidebar />
        <Header />
        <Outlet />
        <Footer />


      </>
    );
  }

  // Only Private page.....
  function PrivateLayout() {
    return (
      <>
        <LanguageProvider>
          <Sidebar />
          <Header />
          <Outlet />
          <Footer />
        </LanguageProvider>
      </>
    );
  }

  return (
    <>
      <Router>
        <LanguageProvider>
          <Routes>

            {/* header and footer is removed this layout */}

            <Route element={<PublicOuter />}>
              <Route path='*' element={<Index />} />
              <Route path='/about' element={<About />} />
              <Route path='/privacy-policy' element={<PrivacyPolicy />} />
              <Route path='/terms-conditions' element={<Terms />} />
              <Route path='/contact' element={<ContactUs />} />
            </Route>

            <Route element={<VerificationLayout />}>
              <Route path='/waiting-conformation' element={<WaitingScreen />} />
              <Route path='/verification/:token' element={<ApprovedScreen />} />
              <Route path='/resetPassword/:username/:token' element={<Forgotconformation />} />
            </Route>

            <Route element={<LoginLayout />}>
              {/* <Route path='' element={<Login pageTitle={`Login | ${titleDescription}`} />} /> */}
              <Route path='/login' element={<Login pageTitle={`Login`} />} />
              <Route path='/admin-login' element={<AdminLogin pageTitle={`Admin Login`} />} />

              <Route path='/register' element={<Register pageTitle={`Register`} />} />
              <Route path='/register/:sponser' element={<Register pageTitle={`Register`} />} />
              <Route path='/forgot' element={<Forgot pageTitle={`Forgot`} />} />
              <Route path='/demo' element={<Demo />} />

              <Route path='/userLogin/:username' element={<AdminSideLogin pageTitle={`Login`} />} />

            </Route>

            {/* All Public pages___ */}
            <Route element={<PrivateRoutes />}>

              <Route element={<PublicLayout />}>
                <Route path='/dashboard' element={<Dashboard pageTitle={`Dashboard`} />} />
                <Route path='/profile' element={<Profile pageTitle={`Profile`} />} />
                <Route path='/deposit-bep20' element={<DepositBEP20 pageTitle={`Deposit`} />} />
                <Route path='/deposit-trc20' element={<DepositTRC20 pageTitle={`trcDeposit`} />} />
                <Route path='/deposit-inr' element={<INRDeposit pageTitle={`INR Deposit`} />} />

                <Route path='/trading-profit' element={<Trading pageTitle={`Trading`} />} />
                <Route path='/buy-infra' element={<BuyInfra pageTitle={`Buy Infra`} />} />
                <Route path='/team' element={<Team pageTitle={`Team`} />} />
                <Route path='/tree' element={<TreeView pageTitle={`Tree`} />} />
                <Route path='/team/:username' element={<TreeView pageTitle={`Team`} />} />
                <Route path='/uni-level' element={<UniLevel pageTitle={`Uni Level`} />} />
                <Route path='/report/:type' element={<DirectIncome pageTitle={`Direct Income`} />} />
                <Route path='/cashflow' element={<Cashflow pageTitle={`Cashflow`} />} />
                <Route path='/overview' element={<Overview pageTitle={`Overview`} />} />
                <Route path='/main-overview' element={<MainOverview pageTitle={`Overview`} />} />
                <Route path='/presentations' element={<Presentations pageTitle={`Presentations`} />} />
                <Route path='/ledger' element={<Ledger pageTitle={`Ledger`} />} />
                <Route path='/ledgerType/:type' element={<LedgerByType pageTitle={`Ledger By Type`} />} />
                <Route path='/crypto-deposit-history' element={<DepositHistory pageTitle={`Deposit History`} />} />
                <Route path='/inr-deposit-history' element={<INRDepositHistory pageTitle={`Deposit History`} />} />
                <Route path='/pay-history' element={<PayHistory pageTitle={`Pay History`} />} />
                <Route path='/trade-withdraw' element={<TradeWithdraw pageTitle={`TradeWithdraw History`} />} />
                <Route path='/salary-withdraw' element={<SalaryWithdraw pageTitle={`SalaryWithdraw History`} />} />
                <Route path='/rankroyalty' element={<RankRoyalty pageTitle={`Rank Royalty`} />} />
                <Route path='/globalpool' element={<Globalpool pageTitle={`Globalpool`} />} />
                <Route path='/create-ticket' element={<Support pageTitle={`Support`} />} />
                <Route path='/ticket-history' element={<TicketView pageTitle={`Ticket View`} />} />
                <Route path='/payout-request' element={<PayoutRequest pageTitle={`Payout Request`} />} />
                <Route path='/trade-transfer' element={<TradeTransfer pageTitle={`Trade Deposit`} />} />
                <Route path='/trade-History' element={<TradeFundHistory pageTitle={`History`} />} />
                <Route path='/capital-withdraw' element={<TradePayout pageTitle={`Trade Withdraw`} />} />
                <Route path='/withdraw-history' element={<CapitalWithdrawHistory pageTitle={`Withdraw History`} />} />
                <Route path='/payout-summary' element={<PayoutSummary pageTitle={`Payout Summary`} />} />
                <Route path='/datewise-summary/:date' element={<DatewiseSummary pageTitle={`DateWise Payout Summary`} />} />
                <Route path='/bot-payout-summary' element={<BotPayoutSummary pageTitle={`Payout Summary`} />} />
                <Route path='/bot-datewise-summary/:date' element={<BotDatewiseSummary pageTitle={`DateWise Payout Summary`} />} />
                <Route path='/directs-list' element={<DirectsList pageTitle={`Directs History`} />} />
                <Route path='/salary-summary' element={<RoyalitySummary pageTitle={`Salary Achievements`} />} />
                <Route path='/compound-bonus' element={<CompoundBonus pageTitle={`Salary Achievements`} />} />
                <Route path='/compounding-deposit' element={<PopupCompounding pageTitle={`compounding Deposit`} />} />
                <Route path='/topup-partially' element={<PartiallyTopup pageTitle={`Partially Topup`} />} />
                <Route path='/stake-compounding' element={<StakeCompounding pageTitle={`Compounding Stake`} />} />
                <Route path='/interest-calculate' element={<CompundInterestCalculator pageTitle={`Calculate Interest`} />} />
                <Route path='/team-trade-business' element={<GetTeamBusiness pageTitle={`Team Trade Business`} />} />
              </Route>
            </Route>

            {/* All Public pages___ */}
            <Route element={<PrivateLayout />}>
              <Route path='/market' element={<Market pageTitle={`Market`} />} />
            </Route>



          </Routes>
        </LanguageProvider>
      </Router >

      <ToastContainer />
    </>
  );
}

export default App;
